<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN ParaOverride-1" id="_idParaDest-6"> </p>
<p class="CHEP_Chapter_epigraph_prose ParaOverride-1"><span class="HPh4_Highlighted_phrase_4">Th</span>e <span class="HPh3_Highlighted_phrase_3">be</span><span class="HPh3_Highlighted_phrase_3"><span class="HPh4_Highlighted_phrase_4">st</span></span>-<span class="HPh3_Highlighted_phrase_3">laid</span> schemes o’ mi<span class="HPh3_Highlighted_phrase_3">ce and men</span></p>
<p class="CHEP_Chapter_epigraph_prose ParaOverride-1">Gang<span class="HPh3_Highlighted_phrase_3"> a</span><span class="HPh3_Highlighted_phrase_3"><span class="HPh4_Highlighted_phrase_4">ft</span></span><span class="HPh3_Highlighted_phrase_3"> agley</span></p>
<p class="CHE1_Chapter_epigraph_other_1 ParaOverride-9"><span class="HPh3_Highlighted_phrase_3"><span class="Serif_SmallCaps CharOverride-4">To a Mouse</span></span></p>
<p class="CHE1_Chapter_epigraph_other_1 ParaOverride-10"><span class="Serif_SmallCaps CharOverride-5">Ro</span><span class="HPh3_Highlighted_phrase_3"><span class="Serif_SmallCaps CharOverride-5">bert Burns</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802159038-5.vue?3205c920